import { Button, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import { LogoLetter } from "assets/icons/LogoLetter";
import { useDispatch, useSelector } from "react-redux";
import {
  useResendVerificationCodeMutation,
  useVerifyCodeMutation,
} from "store/auth/auth.api";
import { setCredentials } from "store/slices/auth.slice";
import {
  CodeInput,
  CodeInputContainer,
  Container,
  FooterText,
  LogoContainer,
  ResendLink,
  StyledTitle,
  SubTitle,
} from "./ConfirmEmail.style";
import { PATHS } from "config/paths";

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const email = location.state?.email || "";
  const [verifyCode, { isLoading }] = useVerifyCodeMutation();
  const [resendCode, { isLoading: isResending }] =
    useResendVerificationCodeMutation();

  const [codeDigits, setCodeDigits] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);
  const handleResendCode = async () => {
    if (!email) return toast.error("Email manquant.");

    try {
      const res = await resendCode({ email }).unwrap();
      toast.success(res?.message || "Code de vérification renvoyé !");
    } catch (err) {
      toast.error(err?.data?.message || "Impossible de renvoyer le code.");
    }
  };
  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newDigits = [...codeDigits];
    newDigits[index] = value;
    setCodeDigits(newDigits);

    if (value && index < codeDigits.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !codeDigits[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (user) {
      console.log("✅ Utilisateur connecté :", user);
    }
  }, [user]);

  const handleSubmit = async () => {
    const verificationCode = codeDigits.join("");
    if (verificationCode.length !== 4 || !email) {
      toast.error("Veuillez entrer un code complet.");
      return;
    }

    try {
      const res = await verifyCode({ email, verificationCode }).unwrap();

      toast.success(res.data?.message || "Code vérifié avec succès");
      console.log("✅ Code vérifié :", res);

      if (res?.data?.user && res?.data?.access_token) {
        dispatch(
          setCredentials({
            user: res.data.user,
            token: res.data.access_token,
          })
        );
      }

      navigate(PATHS.DASHBOARD_USER);
    } catch (err) {
      toast.error(err?.data?.message || "Échec de la vérification");
    }
  };
  return (
    <Container spacing={4}>
      <ToggleSwitch />

      <Stack
        spacing={4}
        alignItems="center"
        sx={{
          backgroundColor: "white",
          borderRadius: "24px",
          padding: "3rem",
        }}>
        <LogoContainer>
          <LogoLetter />
        </LogoContainer>
        <Stack spacing={1} alignItems="center">
          <StyledTitle variant="h5">{t("login.confirmEmail")}</StyledTitle>
          <SubTitle>{t("login.enterCodeInstruction")}</SubTitle>
        </Stack>
        <CodeInputContainer>
          {codeDigits.map((digit, index) => (
            <CodeInput
              key={index}
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              ref={(el) => (inputsRef.current[index] = el)}
            />
          ))}
        </CodeInputContainer>
        <Button variant="contained" onClick={handleSubmit} disabled={isLoading}>
          {t("login.confirm")}
        </Button>
        <ResendLink onClick={handleResendCode} disabled={isResending}>
          {t("login.resendEmail")}
        </ResendLink>
      </Stack>

      <FooterText>{t("login.contactSupport")}</FooterText>
    </Container>
  );
};

export default ConfirmEmail;
